import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Store from "@/pages/Store";
import AppDetail from "@/pages/AppDetail";
import Access from "@/pages/Access";
import PaymentResult from "@/pages/PaymentResult";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import Refunds from "@/pages/Refunds";

function App() {
  useEffect(() => {
    document.title = "crazyOne — Sovereign Android App Store";
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-center"
            theme="dark"
            toastOptions={{
              style: {
                background: "#10131B",
                border: "1px solid #1E2433",
                color: "#F1F5F9",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<Store />} />
            <Route path="/app/:slug" element={<AppDetail />} />
            <Route path="/access" element={<Access />} />
            <Route path="/payment-result" element={<PaymentResult />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refunds" element={<Refunds />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
